// @flow
import * as React from 'react';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';

import type { Props } from './types';

import {
  StyledWrapper, StyledVideo, StyledIconsContainer, StyledIcon
} from './styles';

const Video = ({
  url, posterUrl, type, className
}: Props): React.Node => {
  const ref = React.useRef<HTMLVideoElement | null>(null);
  const [playing, setPlaying] = React.useState(false);

  const videoProps = {
    ref,
    poster: posterUrl || undefined,
    type: type || undefined
  };

  return (
    <StyledWrapper
      className={className}
      onClick={() => {
        if (ref === null || ref.current === null || ref.current.paused === null) {
          return undefined;
        }
        const videoElement: HTMLVideoElement = ref.current;
        togglePlay(videoElement);
        setPlaying(!videoElement.paused);
        return undefined;
      }}
    >
      <StyledVideo {...videoProps}>
        <source src={url} />
      </StyledVideo>
      {!playing && (
        <StyledIconsContainer>
          <StyledIcon icon={faPlayCircle} size="6x" />
        </StyledIconsContainer>
      )}
    </StyledWrapper>
  );
};

const togglePlay = (videoElement: HTMLVideoElement): void => {
  if (videoElement.paused) {
    videoElement.play();
  } else {
    videoElement.pause();
  }
  return undefined;
};

export default Video;
